/**
 * External dependencies
 */
import { createReduxStore, register } from '@wordpress/data';
import * as selectors from './selectors';
import * as actions from './actions';
import reducer from './reducers';
import apiFetch from '@wordpress/api-fetch';

export const YWCDD_STORE_KEY = 'yith/store/ywcdd-delivery';

export const config = {
	reducer,
	selectors,
	actions,
	controls: {
		FETCH_FROM_API( action ) {
			return apiFetch( { path: action.path } );
		},
	},
	resolvers: {
		* initialize( selectedShippingMethod, isEditor = false ) {
			const is_preview = isEditor ? 'yes' : 'no';
			const path = '/ywcdd/v1/dates/initialize?shipping_id=' + selectedShippingMethod+'&is_preview='+is_preview;
			const initialized = yield actions.fetchFromAPI( path );
			initialized.currentRateId = selectedShippingMethod;
			return actions.setInitialized( initialized );
		},
		* updateDates( carrierID, processingMethodID ) {
			const path = '/ywcdd/v1/dates/update_dates?carrier_id=' + carrierID + '&processing_id=' + processingMethodID;
			const payload = yield actions.fetchFromAPI( path );
			payload.selectedCarrierId = carrierID;
			return actions.setDates( payload );
		},
		* updateTimeSlots( carrierID, dateSelected ) {
			const path = '/ywcdd/v1/dates/update_slots?carrier_id=' + carrierID + '&date=' + dateSelected;
			const allSlots = yield actions.fetchFromAPI( path );
			allSlots.selectedDate =  dateSelected;
			return actions.setTimeSlots( allSlots );
		},
		* addCartFee( slotId ) {
			//const path = '/ywcdd/v1/dates/maybe_add_fee?slot_id=' + slotId + '&fee_value=' + feeValue + '&fee_name=' + feeName;
			//const payload = yield actions.fetchFromAPI( path );
			const payload = { selectedSlot: slotId };
			return actions.setTimeSlot( payload );
		},
	},
	__experimentalUseThunks: true,
};

const store = createReduxStore( YWCDD_STORE_KEY, config );
register( store );
